<template>
  <div>
    <el-card class="box-card">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="firstName">
          <el-input v-model="ruleForm.firstName" placeholder="First Name"></el-input>
        </el-form-item>
        <el-form-item prop="lastName">
          <el-input v-model="ruleForm.lastName" placeholder="Last Name"></el-input>
        </el-form-item>
        <el-form-item prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="Company Name" :disabled='isNeedShortName==1'></el-input>
        </el-form-item>
        <el-form-item prop="postcode">
          <el-input v-model="ruleForm.postcode" placeholder="Postcode"></el-input>
        </el-form-item>
        <el-form-item prop="mobileNumber">
          <el-input v-model="ruleForm.mobileNumber" placeholder="Contact number"></el-input>
        </el-form-item>

        <el-form-item>
          <div class="block">
            <el-cascader
              v-model="value"
              :options="options"
              :props="{value:'id',label:'label',leaf:'hasChildren',expandTrigger: 'hover',checkStrictly: true}"
              @change="handleChange"
              placeholder="Select Area"
            ></el-cascader>
          </div>
        </el-form-item>
        <el-form-item v-if="isNeedShortName == 0" prop="shortName">
          <el-input v-model="ruleForm.shortName" placeholder="Invitation code rules"></el-input>
        </el-form-item>

        <el-form-item prop="address">
          <el-input v-model="ruleForm.address" placeholder="address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">Register</el-button>
          <el-button @click="resetForm('ruleForm')">Reset</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        // firstName: '',
        // lastName: '',
        // companyName: '',
        // postcode: '',
        // mobileNumber: '',
        // address: '',
      },
      rules: {
        firstName: [
          {
            required: true,
            message: 'Please enter the first name',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 100,
            message: 'The length is between 2 and 100 characters',
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Please enter the last name',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 100,
            message: 'The length is between 2 and 100 characters',
            trigger: 'blur',
          },
        ],
        postcode: [
          {
            required: true,
            message: 'Please enter the zip code',
            trigger: 'blur',
          },
        ],
        mobileNumber: [
          {
            required: true,
            message: 'Please enter your contact number',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: 'Please enter the detailed address',
            trigger: 'blur',
          },
        ],

        shortName: [
          {
            required: true,
            message: 'Please enter the three-character invitation code rule',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 3,
            message: 'The character length is 3',
            trigger: 'blur',
          },
        ],
      },
      options: [],

      //
      isNeedShortName: '',
      value: '',
    }
  },
  methods: {
    // 提交表单
    submitForm(formName) {
      console.log(this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        this.$post('auth/register', this.ruleForm).then(({ data: res }) => {
          console.log(res)
          if (!res.ok) return this.$message.error(res.msg)
          this.$message.success(res.msg)
          this.$router.push('/login')
        })
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 选择器选择地区赋值
    handleChange(value) {
      this.ruleForm.country = value[0] || ''
      this.ruleForm.state = value[1] || ''
      this.ruleForm.city = value[2] || ''
      this.ruleForm.suburb = value[3] || ''
      console.log(this.ruleForm)
    },
    // 初始化数据，获取公司名称 和 地区表
    initRuleForm() {
      console.log(123)
      this.ruleForm = { ...this.$route.params }
      // 查询公司名称，通过companyType判断是否显示前缀
      this.$get(`auth/checkCompany/${this.ruleForm.invitationCode}`).then(
        ({ data: res }) => {
          this.isNeedShortName = res.data.companyType;
          if(res.data.companyType=='1'){
            this.ruleForm.companyName=res.data.companyName;
          }
          
          console.log(this.isNeedShortName)
        }
      )

      // 查询地区表
      this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(
        ({ data: res }) => {
          this.options = res.data
          console.log(this.options)
        }
      )
    },
  },
  mounted() {
    this.initRuleForm()
    console.log(123)
  },
}
</script>

<style lang="less" scoped>
.el-card {
  width: 480px;
  margin: 100px auto;
}
.el-cascader {
  width: 100%;
}
</style>